export const API_URL = "https://uchida.jikanwari.com/api/";

export const roles = {
  STUDENT: 0,
  TEACHER: 1,
};

export const getHomeRouteName = (role) => {
  if (role === roles.TEACHER) {
    return "home";
  }

  return "timetableWeeklyStudent";
};
